module.exports = __webpack_public_path__ + "media/images/app/homepage/section-rbtd-53aa72105ee2df7cd94aca13a62c3c9e.webp";